import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { BillingConceptEditService } from '../../service/billing-concept-edit/billing-concept-edit.service';

@Component({
	selector: 'app-billing-concept-edit',
	templateUrl: './billing-concept-edit.component.html',
	providers: [
		BillingConceptEditService,
		HttpModule
	]
})
export class BillingConceptEditComponent implements OnInit {

	billingconcept: FormGroup;
	ID: string;
	Nome: string;
	Descricao: string;
	Ativo: boolean;
	private token;
	private sub: any;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private billingconceptEditService: BillingConceptEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.billingconcept = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(2)])],
			'Descricao': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.billingconceptEditService.loadBillingConcept(this.token, this.ID).subscribe(result => {
				var updateclienttype = result.Result;
				this.billingconcept.setValue({
					ID: updateclienttype.ID,
					Nome: updateclienttype.Nome,
					Descricao: updateclienttype.Descricao,
					Ativo: updateclienttype.Ativo
				});
			}, error => {
				console.log(error);
				
			})
		});
	}

	editBillingConcept(value: any) {
		console.log(value);
		this.billingconceptEditService.editBillingConcept(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Conceito de Cobrança editado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/conceito');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/conceito');
	}

}



// WEBPACK FOOTER //
// ./src/app/billing-concept/component/billing-concept-edit/billing-concept-edit.component.ts